import { ResourceEnum } from "src/constants/constants.ts";
import type { TFunction } from "i18next";
import React from "react";
import type { Module } from "src/system/module.types.ts";
import type { AccountingTemplateResource } from "@exonn/js-sdk/src/namespaces/accounting-template";

export const module: Module = {
  id: ResourceEnum.AccountingTemplate,
  bigIcon: <span className={"icon-20-reservation"} />,
  smallIcon: <span className={"icon-15-reservation"} />,
  name: (t: TFunction) => t("moduleName.accounting-template"),
  tabs: {
    edit: {
      getTitle: (resource: AccountingTemplateResource) => resource.title,
    },
  },
};
